(function ($) {
  var $bannerHero = $('.banner-hero');

  if (!$bannerHero.length > 0) return;

  $bannerHero.each(function() {
    var $videoWithLottie = $(this).find('.banner-hero__video-with-lottie');

    
    if (!$videoWithLottie.length > 0) return;
    
    $(this).find('.lottie-wrap').append('<div></div>');
    var lottieContainer = $(this).find('.lottie-wrap').children('div')[0];
    var lottieType = 'donut-waving';
    var lottiePath =
    window.location.origin +
    '/wp-content/themes/ernest/assets/animations/' +
    lottieType +
    '/' +
    lottieType +
    '.json';

      window.addEventListener('load', function (params) {
        var params = {
          container: lottieContainer,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          path: lottiePath,
        };

        var anim;

        anim = lottie.loadAnimation(params);
      });
  })
})(jQuery);